import type { UserCentricsEvent } from '../composables/userCentrics'

import type { RouteLocationNormalized } from '#vue-router'

export default defineNuxtPlugin(async () => {
  const shouldntShowCmp = ['/impressum', '/datenschutz', 'impressum', 'datenschutz']
  const router = useRouter()
  const { pageViewEvent } = useGeneralTracking()
  const referrerStore = useReferrerStore()

  const { initUC, waitForUCInitialization, UCEvents, closeCMP, uc, showFirstLayer } = useUserCentrics()

  initUC()

  // Elbwalker is cookieless tracker and needs to be initialized before any other tracking
  const elbwalker = useElbwalker()
  elbwalker?.init()

  window.addEventListener(UCEvents.UC_UI_CMP_EVENT, (e) => {
    const event = e as UserCentricsEvent
    if (event.detail && (event.detail.type === UCEvents.SAVE || event.detail.type === UCEvents.ACCEPT_ALL)) {
      pageViewEvent(router.currentRoute.value)
    }
  })


  waitForUCInitialization().then(() => {
    router.afterEach((to: RouteLocationNormalized, from: RouteLocationNormalized) => {
      if (uc.value.isConsentRequired()) {
        showFirstLayer()
      }
      if (shouldntShowCmp.includes(to.path)) {
        closeCMP()
      }
      if (to.path !== from.path) {
        pageViewEvent(to)
      }
      referrerStore.setReferrer(from.fullPath)
      referrerStore.setCurrentPath(to.fullPath)
      referrerStore.setRouteName(to.name)
    })
  }).finally(() => {
    if (uc.value?.isConsentRequired()) {
      showFirstLayer()
    }
    if (shouldntShowCmp.includes(router.currentRoute.value.name)) {
      closeCMP()
    }
    pageViewEvent(router.currentRoute.value)
    referrerStore.setReferrer(document.referrer)
    referrerStore.setCurrentPath(router.currentRoute.value.fullPath)
    referrerStore.setRouteName(router.currentRoute.value.name)
  })
})
